module.exports = __webpack_public_path__ + "img/carrousel-video-9.8098f0b8.png";